import React from 'react';
import { connect } from 'react-redux';
import { KeyLicenseTypes } from '../common/keyLicenseTypes';
import { showModalMessage } from '../store/modalsSlice';
import * as objectHistory from '../store/objectHistorySlice';
import { objectHistoryNames, objectHistorySelectors } from '../store/objectHistorySlice';
import { permanentLicensesSelectors } from '../store/permanentLicensesSlice';
import PermanentLicenseHistoryTableHeader from '../components/permanentLicenseHistoryTableHeader';

import KeyLicenseHistoryDialog from '../components/keyLicenseHistoryDialog';

class PermanentLicenseHistoryDialog extends KeyLicenseHistoryDialog {
  get LicenseType() {
    return KeyLicenseTypes.OnlinePermanent;
  }

  renderBeforeContent() {
    const objectData = this.props.selectedPermanentLicense(this.props.id);
    const editedFields = this.props.getEditedFields();
    return <PermanentLicenseHistoryTableHeader editedFields={editedFields} objectData={objectData}/>;
  }
}
const mapStateToProps = (state) => ({
  objectState: objectHistorySelectors.permanentLicenses(state),
  getEditedFields: () => objectHistorySelectors.permanentLicensesEditedFields(state),
  selectedPermanentLicense: (id) => permanentLicensesSelectors.selectById(state, id),
});

const actionCreators = {
  fetchHistory: (id) => objectHistory.fetchHistory(id, objectHistoryNames.permanentLicenses),
  showModalMessage: (title, text) => showModalMessage({ title, text }),
};

export default connect(mapStateToProps, actionCreators)(PermanentLicenseHistoryDialog);



// WEBPACK FOOTER //
// ./src/containers/permanentLicenseHistoryDialog.js